import React, { useEffect, useState } from "react";
import "./index.less";
import { Spin, Tree } from "antd";
import type { TreeDataNode, TreeProps } from "antd";
import LightingInvokeButton from "../WeevilTrakButton/WeevilTrakInvokeButton";
import LightingInvokeStrike from "../WeevilTrakButton/WeevilTrakStage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import { updateCommonWarnMessage,
    updateFinalRequestBoundaryState,
    updateAutoExpandParent,
    updateSelectedKeys,
    updateExpandedKeys,
    updateCheckedKeys,
    updateSelectedCountry,
    updateNeedClearRegion,
    updateFinalRequestBoundaryCode,
    updateIsClickedSearchResultButton,
    updateIsClickedSearchButton}
    from "@/redux/actions/weevilTrakAction";
import { weevilTrakStore } from "@/util/localforageUtils";
import closeIcon from "@/resource/images/png/lightning/close.png";

interface IStateModel{
    stateName?: string;
    cityList?: string[];
}
interface ICodeModel{
    stateName: string;
    stateCode: string;
    cityList?: {
        cityName: string;
        cityCode: string;
    }[];
}

interface IDisplayModel{
    name: string;
    code: string;
}


const WeevilTrakRegion = () => {

    const areasData = useSelector((state: RootState) => state.weevTrakReducer.areasData);
    const finalRequestBoundaryState = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryState);
    const needClearRegion = useSelector((state: RootState) => state.lightningReducer?.needClearRegion);

    const dispatch = useDispatch();

    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
    const [autoExpandParent, setAutoExpandParent] = useState<boolean>(false);

    const [finalTreeData,setFinalTreeData] = useState<TreeDataNode[]>([]);

    useEffect(() => {
        if(checkedKeys?.length >= 1){
            let tmpRequestBoundaryState: string[] = [];
            const tmpCheckedStates:IStateModel[] = [];
            const isAllUsa = checkedKeys?.find(item => item === "United States") !== undefined;
            const isAllCanada = checkedKeys?.find(item => item === "Canada") !== undefined;
            if(isAllUsa || isAllCanada){
                if(isAllUsa) tmpCheckedStates.push({
                    stateName: "United States",
                    cityList: []
                });
                if(isAllCanada) tmpCheckedStates.push({
                    stateName: "Canada",
                    cityList: []
                });
            }
            checkedKeys.forEach((item) => {
                const splitItem = item.toString().split("#");
                if (splitItem.length === 2) { // 确保是国家#州/省格式
                    if(isAllUsa || isAllCanada){
                        if(isAllUsa && splitItem[0] === "United States"){return;}
                        if(isAllCanada && splitItem[0] === "Canada"){return;}
                    }

                    const tmpValue = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    if(!tmpValue) { // 如果不存在这个州/省，则添加
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            cityList: []
                        });}
                }
            });

            // check whether selected all city for state
            tmpRequestBoundaryState = tmpCheckedStates?.map(item => item.stateName) || [];
            dispatch(updateFinalRequestBoundaryState(tmpRequestBoundaryState));
        }
        else{
            dispatch(updateFinalRequestBoundaryState([]));
        }
    },[checkedKeys]);

    useEffect(() => {
        if(checkedKeys?.length >= 1){
            const tmpRequestBoundaryCode: string[] = [];
            const tmpCheckedStates:ICodeModel[] = [];
            const isAllUsa = checkedKeys?.find(item => item === "United States") !== undefined;
            if(isAllUsa){
                dispatch(updateFinalRequestBoundaryCode(["USA"]));
                return;
            }
            checkedKeys.forEach((item) => {
                const splitItem = item.toString().split("#");
                if (splitItem.length === 2) { // 确保是国家#州/省格式
                    const tmpValue = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    const tmpState = areasData?.find(item => item.state === splitItem[1]);
                    if(!tmpValue) { // 如果不存在这个州/省，则添加
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            stateCode: tmpState?.stateCode || "",
                            cityList: []
                        });}
                } else if (splitItem.length === 3) { // 确保是国家#州/省#城市格式
                    const existingState = tmpCheckedStates.find(state => state.stateName === splitItem[1]);
                    const tmpCity = areasData?.find(item => item.state === splitItem[1] && item.city === splitItem[2]);
                    if (existingState) {
                        existingState.cityList?.push({
                            cityName: splitItem[2],
                            cityCode: tmpCity?.cityCode || ""
                        }); // 添加城市到已存在的州/省
                    } else {
                        tmpCheckedStates.push({
                            stateName: splitItem[1],
                            stateCode: tmpCity?.stateCode || "",
                            cityList: [{
                                cityName: splitItem[2],
                                cityCode: tmpCity?.cityCode || ""
                            }]
                        });
                    }
                }
            });

            // check whether selected all city for state
            tmpCheckedStates.forEach((state) => {
                const stateCities = areasData?.filter(item => item.state === state.stateName).map(item => item.city);
                if (stateCities && stateCities.length > 0) {
                    // 如果州/省下有城市，则检查是否选中所有城市
                    const allCitiesSelected = state.cityList?.length === stateCities.length && state.cityList?.every(city => stateCities.includes(city?.cityName));
                    if (allCitiesSelected) {
                        // 如果选中所有城市，则将州/省添加到最终请求边界状态中
                        tmpRequestBoundaryCode.push(state.stateCode);
                    } else {
                        // 否则，添加州/省和选中的城市
                        state?.cityList?.forEach(city => {
                            tmpRequestBoundaryCode.push(city?.cityCode);
                        });
                    }
                } else {
                    // 如果没有城市，则只添加州/省
                    // setFinalRequestBoundaryState(prev => [...prev, `${state.stateName}`]);
                    tmpRequestBoundaryCode.push(state?.stateCode);
                }
            });

            // setFinalRequestBoundaryState(tmpRequestBoundaryState);
            dispatch(updateFinalRequestBoundaryCode(tmpRequestBoundaryCode));
        }
        else{
            dispatch(updateFinalRequestBoundaryCode([]));
        }
    },[checkedKeys]);


    const buildTreeData = (data: IGetCountriesTreeResModel[]) => {
        const treeMap = new Map<string, TreeDataNode>();

        data.forEach(item => {
            if (!item.country || !item.state) return; // 忽略缺少必要信息的项

            const countryKey = `${item.country}`;
            const stateKey = `${countryKey}#${item.state}`;

            // 创建或获取国家节点
            if (!treeMap.has(countryKey)) {
                treeMap.set(countryKey, {
                    title: item.country,
                    key: countryKey,
                    children: [],
                    // disabled: true
                });
            }

            // 获取国家节点，用于添加州/省节点
            const countryNode = treeMap.get(countryKey);

            // 查找是否已有对应的州/省节点
            let stateNode = countryNode?.children?.find(child => child.key === stateKey);

            if (!stateNode) { // 如果没有找到，则创建新的州/省节点
                stateNode = {
                    title: item.state,
                    key: stateKey,
                    children: [],
                };
                countryNode?.children?.push(stateNode);
            }

            // 如果有城市信息，则添加城市节点
            if (item.city) {
                const cityNode: TreeDataNode = {
                    title: item.city,
                    key: `${stateKey}#${item.city}`
                };
                stateNode.children?.push(cityNode);
            }
        });

        // 返回顶级国家节点列表
        // const tmpTreeData = Array.from(treeMap.values()).filter(node => node.key?.toString()?.startsWith("country-"));
        const tmpTreeData = Array.from(treeMap.values()).filter(node => node.key?.toString());
        setFinalTreeData(tmpTreeData);
    };

    const onExpand: TreeProps["onExpand"] = (expandedKeysValue) => {
        setExpandedKeys(expandedKeysValue);
        dispatch(updateExpandedKeys(expandedKeysValue));
        setAutoExpandParent(false);
        dispatch(updateAutoExpandParent(false));
    };

    const onCheck: TreeProps["onCheck"] = (checkedKeysValue) => {
        setCheckedKeys(checkedKeysValue as React.Key[]);
        dispatch(updateCheckedKeys(checkedKeysValue));
    };

    const onSelect: TreeProps["onSelect"] = (selectedKeysValue, info) => {
        console.log("onSelect", info);
        setSelectedKeys(selectedKeysValue);
        console.log("66666 selectedKeysValue",typeof(selectedKeysValue));
        dispatch(updateSelectedKeys(selectedKeysValue));
    };

    const publicDeleteSelectedRegion = (code: string) => {
        const tmpCheckedKeys:string[] = [];
        checkedKeys.forEach((item) => {
            const splitKey = item?.toString().split("#");

            if(code === "United States" || code === "Canada"){

                if(splitKey?.length >= 1 && splitKey[0] === code){
                    return; // skip this item, which means delete this item
                }
                else{
                    tmpCheckedKeys.push(item.toString());
                }
            }
            else{
                if(splitKey?.length === 1){
                    tmpCheckedKeys.push(item.toString());
                }
                const tmpState = areasData?.find(x => x?.state === code); // find current state
                if(tmpState){
                    // mean is state
                    if(splitKey?.length >= 2 && splitKey[1] !== tmpState?.state){
                        tmpCheckedKeys.push(item.toString());
                    }
                }
            }


        });
        setCheckedKeys(tmpCheckedKeys);
        dispatch(updateCheckedKeys(tmpCheckedKeys));
    };

    useEffect(()=>{
        if(areasData?.length >= 1){
            buildTreeData(areasData);
        }
    },[areasData]);

    // for region: when region change, need to clear stage and result
    useEffect(()=>{
        dispatch(updateIsClickedSearchButton(false));
    },[checkedKeys]);

    console.log("lanxue tree data checkedKeys", checkedKeys);
    console.log("lanxue tree data finalRequestBoundaryState", finalRequestBoundaryState);


    // 清除处理函数
    const handleClear = () => {
        // 1. 重置本地状态
        setCheckedKeys([]);
        setSelectedKeys([]);
        // setExpandedKeys(["United States"]);
        setExpandedKeys([]);
        setAutoExpandParent(true);

        // 2. 重置Redux状态（关键：确保彻底清空）
        dispatch(updateCheckedKeys([]));
        dispatch(updateSelectedKeys([]));
        dispatch(updateExpandedKeys([]));
        dispatch(updateAutoExpandParent(true));
        dispatch(updateSelectedCountry([]));
        dispatch(updateFinalRequestBoundaryState([]));
        dispatch(updateFinalRequestBoundaryCode([]));

        dispatch(updateNeedClearRegion(false)); // 重置needClear状态
    };

    // 监听needClear状态，触发清除
    useEffect(() => {
        if (needClearRegion) {
            handleClear();
        }
    }, [needClearRegion]);
    return (
        <div className="weevilTrak-region">
            {/* show selected Region */}
            <div className="weevilTrak-region-title-container">
                <div className="weevilTrak-region-title">
                    Administrative Areas
                </div>
                <div className="weevilTrak-region-selected-container"
                >
                    {
                        finalRequestBoundaryState?.length >= 1 ? (
                            finalRequestBoundaryState.map((item, index) => {
                                return(
                                    <>
                                        <div className="weevilTrak-region-selected-item">
                                            <span>{item}</span>
                                            <span className="weevilTrak-region-selected-item-icon"
                                                onClick={()=>{
                                                    publicDeleteSelectedRegion(item);
                                                }}
                                            >
                                                <img src={closeIcon}></img>
                                            </span>
                                        </div>

                                    </>
                                );
                            })
                        ) : (
                            <span style={{color: "rgba(0, 0, 0, 0.25)"}}></span>
                        )
                    }
                </div>
            </div>
            {/* show Tree Data */}
            <div className="weevilTrak-region-content">
                {/* Region content will be rendered here */}
                <Spin spinning={finalTreeData?.length === 0} tip="Loading...">
                    <Tree
                        checkable
                        onExpand={onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        onCheck={onCheck}
                        checkedKeys={checkedKeys}
                        onSelect={onSelect}
                        selectedKeys={selectedKeys}
                        treeData={finalTreeData}
                    />
                </Spin>

            </div>

            {/* Show Stages */}
            <div className="weevilTrak-region-stage">
                <LightingInvokeStrike />
            </div>

            {/* show button */}
            <div className="weevilTrak-region-button">
                <LightingInvokeButton />
            </div>
        </div>
    );
};

export default WeevilTrakRegion;